
let route = '';
let route1 = '';
let idaasRoute = '';
let reportRoute = '';
let bpmnroute = '';
let ENV = '';
const DomainNameMap = {
  sit: "https://scm-operation-test.csbr.cn",
  uat: "https://scm-operation-pre-test.cs4pl.com",
  pre: "https://scm-operation.cs4pl.com",
  pro: "https://scm-operation.csyaoly.com",
};
if (location.href.indexOf('https://scm-operation.csyaoly.com') > -1) { //生产pro
  route = 'https://scmapi.csyaoly.com';
  bpmnroute = 'https://workflow.cs4pl.com';
  route1 = '/reportapi';
  reportRoute = '//report.csbr.cn/api';
  idaasRoute = '/idaas';
  ENV = 'pro'
} else if (location.href.indexOf('https://scm-operation.cs4pl.com') > -1) { //预生产pre
  route = 'https://scmpreapi.cs4pl.com';
  bpmnroute = 'https://workflow-pre.cs4pl.com';
  route1 = '/reportapi';
  reportRoute = '//report.csbr.cn/api';
  idaasRoute = '/idaas'
  ENV = 'pre'
} else if (location.href.indexOf('https://scm-operation-test.csbr.cn') > -1) { //测试环境1 sit
  route = 'https://zuul.cs4pl.com'
  bpmnroute = 'https://workflow-test.cs4pl.com';
  route1 = '/api';
  reportRoute = '//49.4.23.228:9701';
  idaasRoute = '/idaas'
  ENV = 'sit'
} else if (location.href.indexOf('https://scm-operation-pre-test.cs4pl.com') > -1) { //测试环境2 sit
  // uat
  route = 'https://zuul-test.cs4pl.com'
  bpmnroute = 'https://workflow-pre-test.cs4pl.com';
  route1 = '/api';
  reportRoute = '//49.4.23.228:9701';
  idaasRoute = '/idaas'
  ENV = 'uat'
} else { //测试
  // 本地
  route = 'https://zuul.cs4pl.com'
  bpmnroute = 'https://workflow-test.cs4pl.com';
  route1 = '/api';
  reportRoute = '//49.4.23.228:9701';
  idaasRoute = '/idaas'
  ENV = 'sit'
}

export { route, route1, bpmnroute, reportRoute, idaasRoute, ENV, DomainNameMap };




